import { getTotalChargeAddenda } from '../../util/Billing';
export default {
  id: 'bill.totalCharges',
  name: 'bill.totalCharges',
  displayName: 'Add. Charges',
  valueType: 'number',
  objectType: 'bill',
  placement: {
    group: []
  },
  get: obj => {
    return getTotalChargeAddenda(obj);
  }
};